// Finger-prick / at-home variant titles - subscription step only shown when main product is one of these
var SPECIAL_TITLES_HOME = [
    "Blood taken at home via finger-prick kit",
    "Organise my own blood collection",
    "Collect Sample at Home",
];

function logDiscountDebug(eventName, payload) {
    // TEMP DEBUG: verify exact variants sent to cart for discount matching.
    try {
        console.log('[GBC Discount Debug] ' + eventName, payload);
    } catch (e) {
    }
    try {
        var storageKey = 'gbc_discount_debug_logs';
        var raw = sessionStorage.getItem(storageKey);
        var logs = [];
        if (raw) {
            try {
                logs = JSON.parse(raw) || [];
            } catch (e) {
                logs = [];
            }
        }
        logs.push({
            ts: new Date().toISOString(),
            source: 'section-book-appointment.js',
            event: eventName,
            payload: payload || {},
        });
        if (logs.length > 200) {
            logs = logs.slice(logs.length - 200);
        }
        sessionStorage.setItem(storageKey, JSON.stringify(logs));
    } catch (e) {
    }
}

function gbcGetCluid() {
    var uid = window.CLabsgbVar && window.CLabsgbVar.generalProps && window.CLabsgbVar.generalProps.uid;
    if (uid) {
        try {
            sessionStorage.setItem('gbc_cluid', uid);
        } catch (e) {
        }
        return uid;
    }
    try {
        return sessionStorage.getItem('gbc_cluid') || '';
    } catch (e) {
        return '';
    }
}

jQuery(document).ready(function ($) {
    $('#rcb_calendar_input').change(function () {
        display_month_buttons(this.selectedIndex);
        get_clinic_dates();
    });

    $("#postcode_clinic_search_input").keyup(function (event) {
        if (event.keyCode === 13) {
            $("#postcode_clinic_search").click();
        }
    });
});

document.addEventListener("DOMContentLoaded", function () {
    const postcode_clinic_search_input = document.getElementById("postcode_clinic_search_input");
    if (!postcode_clinic_search_input) return; // Prevents errors on pages without the element
    postcode_cache = sessionStorage.getItem('postCode');
    if (!postcode_cache || postcode_cache == 'undefined') return;
    postcode_clinic_search_input.value = postcode_cache;


});

function isValidDobString(dob) {
    if (!dob || typeof dob !== 'string') return false;
    const m = dob.match(/^(\d{4})-(\d{2})-(\d{2})$/);
    if (!m) return false;
    const y = Number(m[1]);
    const mo = Number(m[2]);
    const d = Number(m[3]);
    if (!y || mo < 1 || mo > 12 || d < 1 || d > 31) return false;
    const dt = new Date(y, mo - 1, d);
    // Guard against JS date overflow (e.g. 2020-02-31 becomes March)
    return dt.getFullYear() === y && (dt.getMonth() + 1) === mo && dt.getDate() === d;
}

function isAtLeast18(dob) {
    if (!isValidDobString(dob)) return false;
    const [y, mo, d] = dob.split('-').map(Number);
    const today = new Date();
    let age = today.getFullYear() - y;
    const monthDiff = (today.getMonth() + 1) - mo;
    if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < d)) {
        age--;
    }
    return age >= 18;
}

function deriveDobFromFormValues(formValues) {
    if (!formValues || typeof formValues !== 'object') return null;

    // Preferred: hidden YYYY-MM-DD input used by booking-save payload
    if (isValidDobString(formValues.bdayinput)) return formValues.bdayinput;

    // Common fallbacks from other form versions
    const possibleKeys = Object.keys(formValues);
    for (const k of possibleKeys) {
        if (!k) continue;
        const lower = String(k).toLowerCase();
        if (!lower.includes('dob') && !lower.includes('dateofbirth') && !lower.includes('date_of_birth')) continue;
        const v = formValues[k];
        if (isValidDobString(v)) return v;
    }

    // Fallback: compose from DD/MM/YYYY widgets
    const y = formValues.bdayyear;
    const m = formValues.bdaymonth;
    const d = formValues.bdayday;
    if (y && m && d) {
        const yy = String(y).padStart(4, '0');
        const mm = String(m).padStart(2, '0');
        const dd = String(d).padStart(2, '0');
        const composed = `${ yy }-${ mm }-${ dd }`;
        return isValidDobString(composed) ? composed : null;
    }

    return null;
}

function shouldEnforceAdultCheck(formEl) {
    if (!formEl) return false;
    // Enforce when a DOB input exists (either our widget or an API-provided DOB field)
    return !!(
        formEl.querySelector('#bdayinput, #bdayday, #bdaymonth, #bdayyear') ||
        formEl.querySelector('[id*="dob" i], [name*="dob" i], [id*="dateofbirth" i], [name*="dateofbirth" i]')
    );
}

/* tests to see if string is in correct UK style postcode: AL1 1AB, BM1 5YZ etc. */
function isValidPostcode(postcode) {
    var postcodeRegEx = /[A-Z]{1,2}[0-9]{1,2}[A-Z]{0,1} ?[0-9][A-Z]{2}/i;
    return postcodeRegEx.test(postcode);
}

/*	formats a VALID postcode nicely: AB120XY -> AB1 0XY */
function formatPostcode(postcode) {
    postcode = postcode.replace(" ", "");
    if (postcode.length > 5) {
        postcode = postcode.substring(0, postcode.length - 3) + " " + postcode.substring(postcode.length - 3);
    }
    return postcode;
}

/*	validates the first part of a postcode */
function isShortenPostcode(postcode) {
    var postRegEx = /^([A-Za-z]{2}[\d]{1,2}[A-Za-z]?)$/;
    return postRegEx.test(postcode);
}

function find_clinic() {
    var postcode = document.getElementById('postcode_clinic_search_input').value;
    const aptTypeId = sessionStorage.getItem('aptId');

    if (!isValidPostcode(postcode) && !isShortenPostcode(postcode)) {
        alert('please enter a valid postcode');
    } else {
        var data = {
            'postcode': postcode,
            'appointmentTypeId': aptTypeId,
        };
        document.getElementById('postcode_clinic_search_result').innerHTML = '<div class="spinner-border"></div>';

        jQuery.ajax({
            url: "https://api.gbc.health/api/v2/shopify-get-clinics",
            type: 'GET',
            data: data,
            success: function (response) {
                var result_block = document.getElementById('postcode_clinic_search_result');
                if (response.isArray && response.length < 1) {
                    result_block.innerHTML = '<br/>We are unable to find any clinics near your area';
                } else {
                    result_block.innerHTML = '';
                    var ii = 1; //print out counter
                    var iii = 1; //list overflow counter
                    var overflow_group_i = 0;
                    var limit_i = 10; //print limit 
                    var hidden_clinics = false;

                    for (i in response) {
                        var block = document.createElement('a');
                        block.classList.add('rcb_sc_clinic_result_block');
                        block.classList.add('bg-light');
                        block.setAttribute('data-bs-target', "#carouselExampleControls");
                        block.setAttribute('data-bs-slide', "next");
                        block.setAttribute('data-clinic_id', response[i].providerId);
                        block.setAttribute('data-clinic_path', response[i].bookingPath);
                        block.setAttribute('data-acuity_calendar_id', response[i].calendarId);
                        block.setAttribute('data-clinic_title', response[i].name);
                        block.addEventListener('click', move_to_step_two);

                        distance = Math.round(response[i].distance)
                        if (distance == 1) {
                            var mile = '&nbsp;Mile'
                        } else {
                            var mile = '&nbsp;Miles'
                        }
                        block.innerHTML = response[i].name + ' <br> <span style="font-weight:normal;">' + response[i].address + ' - ' + distance + mile + '</span>';

                        if (ii > limit_i) {
                            if (!hidden_clinics) {
                                //make more button
                                var more_btn = document.createElement('div');
                                more_btn.classList.add('btn');
                                more_btn.classList.add('pink_btn');
                                more_btn.classList.add('rounded');
                                more_btn.classList.add('text-light');

                                more_btn.classList.add('rcb_more_button');
                                more_btn.style.animationDelay = ((ii - (overflow_group_i * 10)) / 10) + 's';
                                overflow_group_i = 1;
                                more_btn.setAttribute('data-show_element', 'hide_clinic' + overflow_group_i);
                                more_btn.innerHTML = 'Show More';
                                more_btn.addEventListener('click', show_hidden_list);

                                //make more section
                                var more_div = document.createElement('div');
                                more_div.style.display = 'none';
                                more_div.id = 'hide_clinic' + overflow_group_i;
                                more_div.classList.add('rcb_more_section');

                                result_block.appendChild(more_btn);
                                hidden_clinics = true;
                            }

                            block.style.animationDelay = ((ii - (overflow_group_i * 10)) / 10) + 's';
                            more_div.appendChild(block);
                            iii++;
                            if (iii > limit_i) {
                                result_block.appendChild(more_div);
                                overflow_group_i++;
                                //make new more button
                                var more_btn = document.createElement('div');
                                more_btn.classList.add('btn');
                                more_btn.classList.add('text-light');
                                more_btn.classList.add('pink_btn');
                                more_btn.classList.add('rounded');
                                more_btn.classList.add('rcb_more_button');
                                more_btn.setAttribute('data-show_element', 'hide_clinic' + overflow_group_i);
                                more_btn.style.animationDelay = ((ii - (overflow_group_i * 10)) / 10) + 's';
                                more_btn.innerHTML = 'Show More';
                                more_btn.addEventListener('click', show_hidden_list);
                                more_div.appendChild(more_btn);
                                //make new more section
                                more_div = document.createElement('div');
                                more_div.style.display = 'none';
                                more_div.id = 'hide_clinic' + overflow_group_i;
                                more_div.classList.add('rcb_more_section');

                                iii = 1;
                            }
                        } else {
                            block.style.animationDelay = ((ii - (overflow_group_i * 10)) / 10) + 's';
                            result_block.appendChild(block);
                        }
                        ii++;
                    }
                    if (more_div !== 'undefined') {
                        result_block.appendChild(more_div);
                    }
                    const myTimeout = setTimeout(show_mobile_suggestion, 8000);
                }
            },
            error: function (response) {
                var result_block = document.getElementById('postcode_clinic_search_result');
                result_block.innerHTML = '<br/>Your postcode is not recognised. Try using the first part of the postcode only';
            },
        });
    }
}

function show_mobile_suggestion() {
    document.getElementById('postcode_clinic_mobile_link').classList.add('open_bounce_box');
}

function show_hidden_list() {
    var elem_id = this.getAttribute('data-show_element');
    document.getElementById(elem_id).style.display = 'block';
    this.style.display = 'none';

}

function move_to_step_two() {
    const calendarId = this.getAttribute('data-acuity_calendar_id');
    const clinicName = this.getAttribute('data-clinic_title');
    const postCode = document.getElementById('postcode_clinic_search_input').value;

    sessionStorage.setItem('calendarId', calendarId);
    sessionStorage.setItem('clinicName', clinicName);
    sessionStorage.setItem('postCode', postCode);

    window.location.href = '/pages/get-calendar-dates';
}

function getLocation() {
    if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(showPosition, showGLError);
    } else {
        alert('Geolocation is not supported by this browser.');
    }
}

function showPosition(position) {
    const aptTypeId = sessionStorage.getItem('aptId');
    var coord_lat = position.coords.latitude;
    var coord_lng = position.coords.longitude;
    document.getElementById('postcode_clinic_search_result').innerHTML = '<div class="spinner-border"></div>';
    var data = {
        'coord_lat': coord_lat,
        'coord_lng': coord_lng,
        'appointmentTypeId': aptTypeId,
    };
    jQuery.ajax({
        url: "https://api.gbc.health/api/v2/shopify-get-clinics-by-location",
        type: 'GET',
        data: data,
        success: function (response) {
            var result_block = document.getElementById('postcode_clinic_search_result');
            if (response.isArray && response.length < 1) {
                result_block.innerHTML = '<br/>We are unable to find any clinics near your area';
            } else {
                result_block.innerHTML = '';
                var ii = 1; //print out counter
                var iii = 1; //list overflow counter
                var overflow_group_i = 0;
                var limit_i = 10; //print limit 
                var hidden_clinics = false;

                for (i in response) {
                    var block = document.createElement('a');
                    block.classList.add('rcb_sc_clinic_result_block');
                    block.classList.add('bg-light');
                    block.setAttribute('data-bs-target', "#carouselExampleControls");
                    block.setAttribute('data-bs-slide', "next");
                    block.setAttribute('data-clinic_id', response[i].providerId);
                    block.setAttribute('data-clinic_path', response[i].bookingPath);
                    block.setAttribute('data-acuity_calendar_id', response[i].calendarId);
                    block.setAttribute('data-clinic_title', response[i].name);

                    block.addEventListener('click', move_to_step_two);
                    distance = Math.round(response[i].distance)
                    if (distance == 1) {
                        var mile = '&nbsp;Mile'
                    } else {
                        var mile = '&nbsp;Miles'
                    }
                    block.innerHTML = response[i].name + ' <br> <span style="font-weight:normal;">' + response[i].address + ' - ' + distance + mile + '</span>';

                    if (ii > limit_i) {
                        if (!hidden_clinics) {
                            //make more button
                            var more_btn = document.createElement('div');
                            more_btn.classList.add('btn');
                            more_btn.classList.add('pink_btn');
                            more_btn.classList.add('rounded');
                            more_btn.classList.add('text-light');

                            more_btn.classList.add('rcb_more_button');
                            more_btn.style.animationDelay = ((ii - (overflow_group_i * 10)) / 10) + 's';
                            overflow_group_i = 1;
                            more_btn.setAttribute('data-show_element', 'hide_clinic' + overflow_group_i);
                            more_btn.innerHTML = 'Show More';
                            more_btn.addEventListener('click', show_hidden_list);

                            //make more section
                            var more_div = document.createElement('div');
                            more_div.style.display = 'none';
                            more_div.id = 'hide_clinic' + overflow_group_i;
                            more_div.classList.add('rcb_more_section');


                            result_block.appendChild(more_btn);
                            hidden_clinics = true;
                        }

                        block.style.animationDelay = ((ii - (overflow_group_i * 10)) / 10) + 's';
                        more_div.appendChild(block);
                        iii++;
                        if (iii > limit_i) {
                            result_block.appendChild(more_div);
                            overflow_group_i++;
                            //make new more button
                            var more_btn = document.createElement('div');
                            more_btn.classList.add('btn');
                            more_btn.classList.add('text-light');
                            more_btn.classList.add('pink_btn');
                            more_btn.classList.add('rounded');
                            more_btn.classList.add('rcb_more_button');
                            more_btn.setAttribute('data-show_element', 'hide_clinic' + overflow_group_i);
                            more_btn.style.animationDelay = ((ii - (overflow_group_i * 10)) / 10) + 's';
                            more_btn.innerHTML = 'Show More';
                            more_btn.addEventListener('click', show_hidden_list);
                            more_div.appendChild(more_btn);
                            //make new more section
                            more_div = document.createElement('div');
                            more_div.style.display = 'none';
                            more_div.id = 'hide_clinic' + overflow_group_i;
                            more_div.classList.add('rcb_more_section');

                            iii = 1;
                        }
                    } else {
                        block.style.animationDelay = ((ii - (overflow_group_i * 10)) / 10) + 's';
                        result_block.appendChild(block);
                    }
                    ii++;
                }
                if (more_div !== 'undefined') {
                    result_block.appendChild(more_div);
                }
            }
        },
        error: function (response) {
            var result_block = document.getElementById('postcode_clinic_search_result');
            result_block.innerHTML = '<br/>Your postcode is not recognised. Try using the first part of the postcode only';
        },
    });
}


function showGLError(error) {
    switch (error.code) {
        case error.PERMISSION_DENIED:
            alert('Permission denied. Please allow this service to use your device\'s location.');
            break;
        case error.POSITION_UNAVAILABLE:
            alert('Location information is unavailable.');
            break;
        case error.TIMEOUT:
            alert('The request to get user location timed out.');
            break;
        case error.UNKNOWN_ERROR:
            alert('An unknown error occurred.');
            break;
    }
}

document.addEventListener("DOMContentLoaded", function () {
    const title = document.getElementById("clinic_date_title");
    if (!title) return; // Prevents errors on pages without the element
    clinicName = sessionStorage.getItem('clinicName');
    productTitle = sessionStorage.getItem('product_title');

    title.innerHTML = "For: " + clinicName + "<br>" + productTitle;

});


document.addEventListener("DOMContentLoaded", function () {
    const select = document.getElementById("calendar_input");
    if (!select) return; // Prevents errors on pages without the element
    const now = new Date();

    for (let i = 0; i < 4; i++) {
        const monthDate = new Date(now.getFullYear(), now.getMonth() + i, 1);
        const option = document.createElement("option");

        const value = `${ monthDate.getFullYear() }-${ String(monthDate.getMonth() + 1).padStart(2, '0') }`;
        const label = monthDate.toLocaleString('default', { month: 'long', year: 'numeric' });

        option.value = value;
        option.textContent = label;

        select.appendChild(option);
    }
});

function showBookingStep(activeRoot) {
    var containers = [
        document.querySelector('.booking-confirm-container'),
        document.getElementById('subscription-step-root'),
    ];
    containers.forEach(function (el) {
        if (el) el.style.display = (el === activeRoot) ? 'block' : 'none';
    });
}

function buildBookingStepUrl(stepName, fallbackPath) {
    try {
        const url = new URL(window.location.href);
        url.searchParams.delete('subscription');
        if (stepName) url.searchParams.set(stepName, '1');
        const search = url.searchParams.toString();
        return url.pathname + (search ? '?' + search : '') + url.hash;
    } catch (e) {
        const fallback = fallbackPath || window.location.pathname || '/pages/booking-confirm';
        if (!stepName) return fallback;
        const joiner = fallback.indexOf('?') === -1 ? '?' : '&';
        return fallback + joiner + stepName + '=1';
    }
}

function getSubscriptionStepTargetUrl() {
    const hasInlineSubscriptionRoot = !!document.getElementById("subscription-step-root");
    if (!hasInlineSubscriptionRoot) {
        return '/pages/booking-subscription';
    }
    return buildBookingStepUrl('subscription', window.location.pathname || '/pages/booking-confirm');
}

function collectSelectedUpsellsFromDom() {
    const selectedUpsells = [];
    $('.bolt_on_option_box:checked').each(function () {
        const checkbox = this;
        let selling_plans = [];
        try {
            const sp = checkbox.dataset.selling_plans;
            if (sp) selling_plans = JSON.parse(sp.replace(/&quot;/g, '"'));
        } catch (err) {
        }
        selectedUpsells.push({
            id: checkbox.value,
            title: checkbox.dataset.desc_title,
            price: checkbox.dataset.price,
            original_price: checkbox.dataset.original_price || checkbox.dataset.price,
            discount_amount: checkbox.dataset.discount_amount,
            product_id: checkbox.dataset.handle,
            eurofins_code: checkbox.dataset.eurofins_code,
            variant_title: checkbox.dataset.variant_title || '',
            selling_plan_id: checkbox.dataset.selling_plan_id || null,
            selling_plans: selling_plans,
        });
    });
    return selectedUpsells;
}

function getHasMainPlans() {
    var mainPlansStr = sessionStorage.getItem('main_variant_selling_plans');
    var mainPlans = [];
    try {
        if (mainPlansStr) mainPlans = JSON.parse(mainPlansStr);
    } catch (e) {
    }
    return !!(mainPlans && mainPlans.length > 0);
}

function saveUpsellsAndFinish(config) {
    var savePath = (config && config.savePath) ? config.savePath : '/pages/booking-save';
    var selectedUpsells = collectSelectedUpsellsFromDom();
    sessionStorage.setItem('selectedUpsells', JSON.stringify(selectedUpsells));
    logDiscountDebug('Selected upsells before save', {
        save_path: savePath,
        selected_upsells: selectedUpsells.map(function (u) {
            return {
                id: Number(u.id),
                title: u.title || '',
                variant_title: u.variant_title || '',
                product_id: u.product_id || '',
                product_code: u.eurofins_code || '',
            };
        }),
    });
    window.location.href = savePath;
}

function updateConfirmBackLink(selector, defaultPath) {
    var backLink = document.querySelector(selector);
    if (!backLink) return;
    backLink.setAttribute('href', getHasMainPlans() ? getSubscriptionStepTargetUrl() : defaultPath);
}


document.addEventListener("DOMContentLoaded", function () {
    const confirm_div = document.getElementById("confirm_block");
    if (!confirm_div) {
        return; // Prevents errors on pages without the element
    }
    const clinicName = sessionStorage.getItem('clinicName');
    const productTitle = sessionStorage.getItem('product_title');
    const timeCode = sessionStorage.getItem('timecode');
    const variantId = sessionStorage.getItem('variant_id');

    const date = new Date(timeCode);

    // Extract parts
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');

    // Build final string
    const formattedDate = `${ day }/${ month }/${ year } at ${ hours }:${ minutes }`;

    var confirm_Html = "<p><b>" + productTitle + "</b></p>"
    //var confirm_Html = confirm_Html + "<p><b>" + variantId + "</b></p>"
    confirm_Html = confirm_Html + "<p><b>Blood taken by a professional in-clinic</b></p><br><br>"

    confirm_Html = confirm_Html + "<p>" + clinicName + "</p>"
    confirm_Html = confirm_Html + "<p>" + formattedDate + "</p>"
    confirm_div.innerHTML = confirm_Html;


});

document.addEventListener("DOMContentLoaded", function () {
    const confirm_div = document.getElementById("confirm_save");
    if (!confirm_div) {
        return; // Prevents errors on pages without the element
    }
    const timeCode = sessionStorage.getItem('timecode');
    const aptTypeId = sessionStorage.getItem('aptId');
    const calendarId = sessionStorage.getItem('calendarId');
    const variantId = sessionStorage.getItem('variant_id');

    const storedData = sessionStorage.getItem('formValues');
    console.log(variantId);

    if (!storedData) return;
    let formValues; // use let so we can assign to it later
    try {
        formValues = JSON.parse(storedData);
    } catch (e) {
        console.error('Bad JSON in sessionStorage.formValues', storedData, e);
        return;
    }
    const data = JSON.stringify({
        'appointmentTypeId': aptTypeId,
        'calendarId': calendarId,
        'timeSlot': timeCode,
        'firstName': formValues.InputFName,
        'lastName': formValues.InputSName,
        'email': formValues.InputEmail,
        'phoneNumber': formValues.InputPhone,
        'formData': formValues,
        'cluid': gbcGetCluid(),
    });
    console.log('[GBC cluid] shopify-make-booking cluid:', gbcGetCluid());

    jQuery.ajax({
        url: "https://api.gbc.health/api/v2/shopify-make-booking",
        type: 'POST',
        data: data,
        contentType: 'application/json',  // send JSON
        processData: false,               // don't URL encode
        success: function (response) {
            console.log('✅ Success:', response.id);

            addToCartFromSession(response.id);

        },
        error: function (xhr, status, error) {
            console.error('❌ Error:', error, xhr.responseText);
        },
    });
});

document.addEventListener('DOMContentLoaded', function () {
    const link = document.getElementById('back-to-product');
    const handle = sessionStorage.getItem('real_product_handle');

    if (!link) return;

    if (handle) {
        link.href = `/products/${ handle }`;
    } else {
        // optional fallback
        link.href = '/collections/all';
    }
});


async function addToCartFromSession(appointmentId) {
    try {
        const variantId = sessionStorage.getItem('variant_id');
        const productHandle = sessionStorage.getItem('product_handle');
        const eurofinsCode = sessionStorage.getItem('eurofinsCode');

        console.log(variantId);
        // 1) Build payload with line item properties; include selling_plan when user chose Subscribe on subscription step
        var subscriptionChoices = null;
        try {
            var sc = sessionStorage.getItem('subscription_choices');
            if (sc) subscriptionChoices = JSON.parse(sc);
        } catch (e) {
        }

        var mainSellingPlanId = subscriptionChoices && subscriptionChoices.main ? Number(subscriptionChoices.main) : null;
        var mainAllowedPlanIds = [];
        try {
            var mainPlansRaw = sessionStorage.getItem('main_variant_selling_plans');
            var mainPlans = mainPlansRaw ? JSON.parse(mainPlansRaw) : [];
            if (Array.isArray(mainPlans)) {
                mainAllowedPlanIds = mainPlans
                    .map(function (p) {
                        return p && p.id ? Number(p.id) : null;
                    })
                    .filter(function (id) {
                        return !!id;
                    });
            }
        } catch (e) {
        }
        if (!mainAllowedPlanIds.includes(mainSellingPlanId)) {
            mainSellingPlanId = null;
        }

        const items = [
            {
                id: Number(variantId), // Shopify variant ID
                quantity: 1,
                properties: {
                    appointmentId: String(appointmentId),
                    product_id: productHandle,
                    product_code: eurofinsCode,
                },
            },
        ];
        if (mainSellingPlanId) items[0].selling_plan = mainSellingPlanId;

        const upsells = sessionStorage.getItem('selectedUpsells');
        if (upsells) {
            const upsellProducts = JSON.parse(upsells);
            var upsellChoices = (subscriptionChoices && subscriptionChoices.upsells) ? subscriptionChoices.upsells : [];
            upsellProducts.forEach(function (u) {
                var choice = upsellChoices.find(function (c) {
                    return c.variant_id === Number(u.id);
                }) || {};
                var sellingPlanId = choice.selling_plan_id ? Number(choice.selling_plan_id) : null;
                var upsellAllowedPlanIds = [];
                if (Array.isArray(u.selling_plans) && u.selling_plans.length) {
                    upsellAllowedPlanIds = u.selling_plans
                        .map(function (p) {
                            return p && p.id ? Number(p.id) : null;
                        })
                        .filter(function (id) {
                            return !!id;
                        });
                } else if (u.selling_plan_id) {
                    upsellAllowedPlanIds = [Number(u.selling_plan_id)];
                }
                if (!upsellAllowedPlanIds.includes(sellingPlanId)) {
                    sellingPlanId = null;
                }
                var item = {
                    id: Number(u.id),
                    quantity: 1,
                    properties: {
                        product_id: u.product_id,
                        product_code: u.eurofins_code,
                    },
                };
                if (sellingPlanId) item.selling_plan = sellingPlanId;
                items.push(item);
            });
        }

        logDiscountDebug('Cart add payload', {
            appointment_id: appointmentId,
            main_variant_id: Number(variantId),
            main_product_handle: productHandle,
            selected_upsells_from_session: (function () {
                try {
                    const raw = sessionStorage.getItem('selectedUpsells');
                    if (!raw) return [];
                    return JSON.parse(raw).map(function (u) {
                        return {
                            id: Number(u.id),
                            title: u.title || '',
                            variant_title: u.variant_title || '',
                            product_id: u.product_id || '',
                            product_code: u.eurofins_code || '',
                        };
                    });
                } catch (e) {
                    return [];
                }
            })(),
            cart_items: items,
        });

        // 2) Add to cart
        const res = await fetch('/cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            },
            body: JSON.stringify({ items }),
            credentials: 'same-origin',
        });

        if (!res.ok) {
            const errText = await res.text();
            console.error('Add to cart failed:', errText);
            alert('Could not add item to cart.');
            return;
        }

        var query_string = "";
        const use_at_billing = sessionStorage.getItem('use_at_billing');
        if (use_at_billing && use_at_billing == 'yes') {
            const patientAddress1 = sessionStorage.getItem('patientAddress1');
            const patientAddress2 = sessionStorage.getItem('patientAddress2');
            const patientAddressStreet = sessionStorage.getItem('patientAddressStreet');
            const patientAddressTown = sessionStorage.getItem('patientAddressTown');
            const postCode = sessionStorage.getItem('postCode');
            query_string = query_string + '?checkout[shipping_address][address1]=' + patientAddress1 + " " + patientAddressStreet;
            query_string = query_string + '&checkout[shipping_address][address2]=' + patientAddress2;
            query_string = query_string + '&checkout[shipping_address][city]=' + patientAddressTown;
            query_string = query_string + '&checkout[shipping_address][zip]=' + postCode;
            query_string = query_string + '&checkout[billing_address][address1]=' + patientAddress1 + " " + patientAddressStreet;
            query_string = query_string + '&checkout[billing_address][address2]=' + patientAddress2;
            query_string = query_string + '&checkout[billing_address][city]=' + patientAddressTown;
            query_string = query_string + '&checkout[billing_address][zip]=' + postCode;
        }

        const storedData = sessionStorage.getItem('formValues');
        let formValues; // use let so we can assign to it later
        try {
            formValues = JSON.parse(storedData);
        } catch (e) {
            console.error('Bad JSON in sessionStorage.formValues', storedData, e);
            return;
        }

        if (formValues.billingCheck && formValues.billingCheck == 'on') {
            const email = formValues.InputEmail;
            const phone = formValues.InputPhone;
            const firstname = formValues.InputFName;
            const lastname = formValues.InputSName;
            if (query_string == "") {
                query_string = "?";
            } else {
                query_string = query_string + "&";
            }
            query_string = query_string + 'checkout[shipping_address][first_name]=' + firstname;
            query_string = query_string + '&checkout[shipping_address][last_name]=' + lastname;
            query_string = query_string + '&checkout[email]=' + email;
            query_string = query_string + '&checkout[shipping_address][phone]=' + phone;
            query_string = query_string + '&checkout[billing_address][first_name]=' + firstname;
            query_string = query_string + '&checkout[billing_address][last_name]=' + lastname;
            query_string = query_string + '&checkout[billing_address][phone]=' + phone;
        }

        //window.location.href ='/cart';
        //3) Redirect to cart
        window.location.href = '/checkout' + query_string;
    } catch (e) {
        console.error(e);
        alert('Something went wrong adding the item to cart.');
    }
}

let hasAutoAdvancedMonth = false;

function updateMonthSelect() {
    const select = document.getElementById('calendar_input');
    const prevBtn = document.getElementById('shift-last-month');
    const nextBtn = document.getElementById('shift-next-month');

    const currentIndex = select.selectedIndex;
    const totalOptions = select.options.length;

    // Hide previous button if currentIndex is 0 (first option)
    prevBtn.style.display = currentIndex === 0 ? 'none' : 'block';

    // Hide next button if currentIndex is last
    nextBtn.style.display = currentIndex === totalOptions - 1 ? 'none' : 'block';

    const aptTypeId = sessionStorage.getItem('aptId');
    const calendarId = sessionStorage.getItem('calendarId');
    const ym = select.value;

    document.getElementById('calendar_body').innerHTML = '<div class="spinner-border"></div>';
    var data = {
        'calendarId': calendarId,
        'appointmentTypeId': aptTypeId,
        'ym': ym,
    };
    jQuery.ajax({
        url: "https://api.gbc.health/api/v2/shopify-get-calendar-dates",
        type: 'GET',
        data: data,
        success: function (response) {
            document.getElementById('calendar_body').innerHTML = response;
            var dates = document.querySelectorAll('.calendar_status_open');
            for (var i = 0; i < dates.length; i++) {
                dates[i].addEventListener('click', get_times);
            }
        },
        error: function (response) {
            if (currentIndex === 0 && !hasAutoAdvancedMonth) {
                hasAutoAdvancedMonth = true;
                shift_next_month();
                return;
            }
            document.getElementById('calendar_body').innerHTML = '<tr><td colspan=7 style="font-weight:bold;">No availability for this month</td></tr>';
        },
    });
}


document.addEventListener("DOMContentLoaded", function () {
    const calendarInput = document.getElementById('calendar_input');
    if (calendarInput) {
        updateMonthSelect(); // also run once on load
        calendarInput.addEventListener('change', updateMonthSelect);
    }

    const patient_form = document.getElementById('patient_booking_form');
    if (patient_form) {
        patient_form.innerHTML = '';
        const aptTypeId = sessionStorage.getItem('aptId');
        var data = {
            'appointmentTypeId': aptTypeId,
            'cluid': gbcGetCluid(),
        };
        console.log('[GBC cluid] shopify-get-patient-form (clinic) cluid:', data.cluid);
        jQuery.ajax(
            {
                url: "https://api.gbc.health/api/v2/shopify-get-patient-form",
                type: 'get',
                data: data,
                success: function (response) {
                    if (response.form) {
                        patient_form.innerHTML = response.form.form;
                    }
                },
            });

        const p_form = document.getElementById('patient-details');
        setTimeout(() => {
            const p_inputs = p_form.querySelectorAll('input, select, textarea'); // get all input fields
            formValues = sessionStorage.getItem('formValues');
            if (formValues) {
                data = JSON.parse(formValues);
                p_inputs.forEach(el => {
                    const key = el.id || el.name;
                    const val = data[key];
                    if (el.tagName === 'SELECT') {
                        if ([...el.options].some(o => o.value == val)) {
                            el.value = val;
                        }
                        el.dispatchEvent(new Event('change', { bubbles: true }));
                    } else if (el.type === 'checkbox') {
                        // store booleans as true/false when saving
                        el.checked = !!val || val === 'true' || val === 'on';
                        el.dispatchEvent(new Event('change', { bubbles: true }));

                    } else if (el.type === 'radio') {
                        // expect radios saved by name -> value
                        if (el.name && data[el.name] != null) {
                            el.checked = (el.value == data[el.name]);
                            if (el.checked) el.dispatchEvent(new Event('change', { bubbles: true }));
                        }
                    } else {
                        el.value = val ?? '';
                        el.dispatchEvent(new Event('input', { bubbles: true }));
                        el.dispatchEvent(new Event('change', { bubbles: true }));
                    }
                });
            }
        }, 1500);

    }
});


function shift_last_month() {
    const select = document.getElementById('calendar_input');
    if (select.selectedIndex > 0) {
        select.selectedIndex--;
        select.dispatchEvent(new Event('change')); // trigger change event
    }
}

function shift_next_month() {
    const select = document.getElementById('calendar_input');
    if (select.selectedIndex < select.options.length - 1) {
        select.selectedIndex++;
        select.dispatchEvent(new Event('change')); // trigger change event
    }
}

function get_times() {
    var dates = document.querySelectorAll('.active_date');
    for (var i = 0; i < dates.length; i++) {
        dates[i].classList.remove('active_date');
    }
    this.classList.add('active_date');
    var date = this.getAttribute('data-date');
    document.getElementById('times_body').innerHTML = '<div class="spinner-border"></div>';
    if (window.innerWidth <= 768) {
        document.getElementById("times_body").scrollIntoView({
            behavior: "smooth",  // optional: animated scroll
            block: "start",       // aligns the top of element with top of screen
        });
    }

    const calendarId = sessionStorage.getItem('calendarId');
    const aptTypeId = sessionStorage.getItem('aptId');
    var data = {
        'selected_date': date,
        'appointmentTypeId': aptTypeId,
        'calendarId': calendarId,
        'cluid': gbcGetCluid(),
    };
    console.log('[GBC cluid] shopify-get-calendar-times cluid:', data.cluid);
    jQuery.ajax({
        url: "https://api.gbc.health/api/v2/shopify-get-calendar-times",
        type: 'GET',
        data: data,
        success: function (response) {
            if (typeof response === 'object' && response && Object.keys(response).length > 0) {
                document.getElementById('times_body').innerHTML = response[0];
                if (window.innerWidth <= 768) {
                    document.getElementById("times_body").scrollIntoView({
                        behavior: "smooth",  // optional: animated scroll
                        block: "start",       // aligns the top of element with top of screen
                    });
                }
            }
        },
    });
}

function get_patient_page(time, timecode) {
    sessionStorage.setItem('time', time);
    sessionStorage.setItem('timecode', timecode);

    window.location.href = '/pages/patient-details';

}

function submit_patient_form(event) {
    const form = document.getElementById('patient-details');
    const formValues = {};

    if (form) {
        const inputs = form.querySelectorAll('input, select, textarea'); // get all input fields
        inputs.forEach(input => {
            if (input.id) {
                formValues[input.id] = input.value;
            }
        });
    }

    // 18+ gate (only enforce when the form actually contains a DOB field)
    if (shouldEnforceAdultCheck(form)) {
        const dob = deriveDobFromFormValues(formValues);
        if (!dob) {
            alert('Please enter a valid Date of Birth (18+ only) to continue.');
            return false;
        }
        // Normalize so downstream code always has a single key
        formValues.bdayinput = dob;
        if (!isAtLeast18(dob)) {
            alert('Sorry — you must be 18+ to continue.');
            return false;
        }
    }

    sessionStorage.setItem('formValues', JSON.stringify(formValues));

    if (getHasMainPlans()) {
        sessionStorage.setItem('subscription_save_path', '/pages/booking-confirm');
        sessionStorage.setItem('subscription_back_path', '/pages/patient-details');
        sessionStorage.removeItem('selectedUpsells');
        window.location.href = '/pages/booking-confirm?subscription=1';
    } else {
        sessionStorage.removeItem('subscription_choices');
        window.location.href = '/pages/booking-confirm';
    }
    return false;
}

function update_bdate() {
    var bday = document.getElementById('bdayday').value;
    var bmonth = document.getElementById('bdaymonth').value;
    var byear = document.getElementById('bdayyear').value;

    bday = String(bday).padStart(2, '0');
    bmonth = String(bmonth).padStart(2, '0');
    var value = byear + '-' + bmonth + '-' + bday;

    document.querySelectorAll('.bdayinput').forEach(function (el) {
        el.value = value;
    });
}

document.addEventListener("DOMContentLoaded", function () {
    const postcode_mob_service_search_input = document.getElementById("postcode_mob_service_search_input");
    if (!postcode_mob_service_search_input) return; // Prevents errors on pages without the element
    postcode_cache = sessionStorage.getItem('postCode');
    if (!postcode_cache || postcode_cache == 'undefined') return;
    postcode_mob_service_search_input.value = postcode_cache;
    findServiceProvidersPostcode();
});

function findServiceProvidersPostcode() {
    document.getElementById('postcode_locations_search_mob_result').innerHTML = '';
    var postcode = document.getElementById('postcode_mob_service_search_input').value;
    elems = document.querySelectorAll('.address_mobile_inputs');
    for (let i = 0; i < elems.length; i++) {
        elems[i].disabled = true;
    }
    document.getElementById('Address_line_1').value = '';
    document.getElementById('Address_line_2').value = '';
    document.getElementById('Address_street').value = '';
    document.getElementById('Address_post_town').value = '';
    const url = "https://api.gbc.health/api/v2/shopify-get-mobile-clinics";
    var data = {
        'postcode': postcode,
    };
    jQuery.ajax({
        url: "https://api.gbc.health/api/v2/shopify-get-mobile-clinics",
        type: 'GET',
        data: data,
        success: function (response) {
            document.getElementById('postcode_mob_service_search_hidden_input').value = document.getElementById('postcode_mob_service_search_input').value;
            document.getElementById('postcode_clinic_search_mob').style.display = 'none';
            document.getElementById('postcode_clinic_search_mob_loc').style.display = 'none';
            document.getElementById('postcode_mob_service_search_input').disabled = true;
            document.getElementById('change_postcode_button').style.display = 'block';
            document.getElementById('further_controls').style.display = 'block';
            var result_block = document.getElementById('postcode_locations_search_mob_result');
            result_block.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40" fill="currentColor"><path class="st0" d="M27.8084381,14.9277643c.5345737.53398.5350564,1.400213.0010751,1.9347867-.0003575.0003588-.000715.0007176-.0010751.0010764l-9.5767082,9.5767095c-.53398.5345737-1.400213.5350564-1.9347867.0010751-.0003588-.0003575-.0007176-.000715-.0010764-.0010751l-4.1043035-4.1043035c-.5345737-.5345737-.534575-1.4012907,0-1.9358644.5345737-.5345737,1.4012894-.5345737,1.9358631,0l3.1363713,3.1380831,8.608776-8.6104865c.5339787-.534575,1.400213-.5350577,1.9347867-.001079.0003601.0003588.0007176.0007189.0010777.0010777ZM37.7853152,20c0,9.8225571-7.9627581,17.7853152-17.7853152,17.7853152S2.2146848,29.8225571,2.2146848,20,10.1774415,2.2146848,20,2.2146848c9.8182594.0103686,17.7749453,7.9670558,17.7853152,17.7853152ZM35.0491129,20c0-8.3113957-6.7377172-15.0491129-15.0491129-15.0491129s-15.0491129,6.7377172-15.0491129,15.0491129,6.7377172,15.0491129,15.0491129,15.0491129c8.3074894-.0094253,15.0396876-6.7416235,15.0491129-15.0491129Z"/></svg>';
            result_block.innerHTML += 'Good News! We have found providers in your area. please enter where you would like your appointment to take place below to continue';
            elems = document.querySelectorAll('.address_mobile_inputs');
            for (let i = 0; i < elems.length; i++) {
                elems[i].disabled = false;
            }
            result_block.style.display = "block";
            document.getElementById('Address_street').value = response.street;
            document.getElementById('Address_post_town').value = response.town;

        },
        error: function (xhr) {
            var result_block = document.getElementById('postcode_locations_search_mob_result');
            var message = "An error occurred";

            if (xhr.responseJSON && xhr.responseJSON.message) {
                message = xhr.responseJSON.message; // safest way
            } else if (xhr.responseText) {
                try {
                    var parsed = JSON.parse(xhr.responseText);
                    if (parsed.message) {
                        message = parsed.message;
                    }
                } catch (e) {
                }
            }

            result_block.innerHTML = `<div class="d-flex pt-3">
        <div class="dashicons dashicons-no text-danger mx-1"></div>
        <div>${ message }</div>
        </div>`;
        },
    });

    $('#confirm_continue_btn').on('click', function (e) {
        if (document.getElementById('Address_line_1').value != '' &&
            document.getElementById('Address_street').value != '' &&
            document.getElementById('Address_post_town').value != ''
        ) {
            e.preventDefault();
            sessionStorage.setItem('patientAddress1', document.getElementById('Address_line_1').value);
            sessionStorage.setItem('postCode', document.getElementById('postcode_mob_service_search_input').value);
            sessionStorage.setItem('patientAddress2', document.getElementById('Address_line_2').value);
            sessionStorage.setItem('patientAddressStreet', document.getElementById('Address_street').value);
            sessionStorage.setItem('patientAddressTown', document.getElementById('Address_post_town').value);
            if (document.getElementById('use_at_billing').checked) {
                sessionStorage.setItem('use_at_billing', 'yes');
            } else {
                sessionStorage.setItem('use_at_billing', 'no');
            }
            console.log(document.getElementById('postcode_mob_service_search_input').value);
            window.location.href = '/pages/get-prefered-dates';
        }

    });

}

function change_postcode() {
    document.getElementById('change_postcode_button').style.display = 'none';
    document.getElementById('further_controls').style.display = 'none';
    document.getElementById('postcode_mob_service_search_input').disabled = false;
    document.getElementById('postcode_clinic_search_mob').style.display = 'block';
    document.getElementById('postcode_clinic_search_mob_loc').style.display = 'block';
    document.getElementById('postcode_locations_search_mob_result').innerHTML = '';
    document.getElementById('Address_line_1').value = '';
    document.getElementById('Address_line_2').value = '';
    document.getElementById('Address_street').value = '';
    document.getElementById('Address_post_town').value = '';

    elems = document.querySelectorAll('.address_mobile_inputs');
    for (let i = 0; i < elems.length; i++) {
        elems[i].disabled = true;
    }
}

function check_completed_date_select() {
    var day1 = document.getElementById('choose_day_1').value;
    var day2 = document.getElementById('choose_day_2').value;
    var day3 = document.getElementById('choose_day_3').value;

    var day_check = [false, false, false];
    if (day1 == '') {
        day_check[1] = 'empty';
    }
    if (day2 == '') {
        day_check[2] = 'empty';
    }
    if (day3 == '') {
        day_check[3] = 'empty';
    }

    var match_flag = false;

    if (day1 != '' && day1 == day2) {
        day_check[1] = 'match';
        day_check[2] = 'match';
        match_flag = true;
    }

    if (day3 != '' && day1 == day3) {
        day_check[1] = 'match';
        day_check[3] = 'match';
        match_flag = true;
    }

    if (day3 != '' && day2 == day3) {
        day_check[2] = 'match';
        day_check[3] = 'match';
        match_flag = true;
    }

    if (match_flag) {
        document.getElementById('line_status_bad_message').style.display = 'block';
    } else {
        document.getElementById('line_status_bad_message').style.display = 'none';
    }

    if (!day_check[1]) {
        document.getElementById('line_status1good').style.display = 'block';
        document.getElementById('line_status1bad').style.display = 'none';
    } else if (day_check[1] == 'empty') {
        document.getElementById('line_status1good').style.display = 'none';
        document.getElementById('line_status1bad').style.display = 'none';
    } else if (day_check[1] == 'match') {
        document.getElementById('line_status1good').style.display = 'none';
        document.getElementById('line_status1bad').style.display = 'block';
    }

    if (!day_check[2]) {
        document.getElementById('line_status2good').style.display = 'block';
        document.getElementById('line_status2bad').style.display = 'none';
    } else if (day_check[2] == 'empty') {
        document.getElementById('line_status2good').style.display = 'none';
        document.getElementById('line_status2bad').style.display = 'none';
    } else if (day_check[2] == 'match') {
        document.getElementById('line_status2good').style.display = 'none';
        document.getElementById('line_status2bad').style.display = 'block';
    }

    if (!day_check[3]) {
        document.getElementById('line_status3good').style.display = 'block';
        document.getElementById('line_status3bad').style.display = 'none';

    } else if (day_check[3] == 'empty') {
        document.getElementById('line_status3good').style.display = 'none';
        document.getElementById('line_status3bad').style.display = 'none';
    } else if (day_check[3] == 'match') {
        document.getElementById('line_status3good').style.display = 'none';
        document.getElementById('line_status3bad').style.display = 'block';
    }

    if (day1 != '' && day2 != '' && day3 != '' && !match_flag) {
        document.getElementById('days_page_continue_btn').style.display = 'block';
    } else {
        document.getElementById('days_page_continue_btn').style.display = 'none';
    }

}

function preferred_days_continue() {
    sessionStorage.setItem('mobileDay1', document.getElementById('choose_day_1').value);
    sessionStorage.setItem('mobileDay2', document.getElementById('choose_day_2').value);
    sessionStorage.setItem('mobileDay3', document.getElementById('choose_day_3').value);

    window.location.href = '/pages/mobile-patient-details';

}

document.addEventListener("DOMContentLoaded", function () {
    const day1_input = document.getElementById('choose_day_1');
    if (!day1_input) return; // Prevents errors on pages without the element
    const day2_input = document.getElementById('choose_day_2');
    const day3_input = document.getElementById('choose_day_3');

    var check_completed = false;
    setTimeout(() => {
        day1_value = sessionStorage.getItem('mobileDay1');
        if (day1_value && day1_value != 'undefined') {
            day1_input.value = day1_value;
            check_completed = true;
        }

        day2_value = sessionStorage.getItem('mobileDay2');
        if (day2_value && day2_value != 'undefined') {
            day2_input.value = day2_value;
            check_completed = true;
        }

        day3_value = sessionStorage.getItem('mobileDay3');
        if (day3_value && day3_value != 'undefined') {
            day3_input.value = day3_value;
            check_completed = true;
        }
        if (check_completed) {
            check_completed_date_select();
        }

    }, 250);


});


document.addEventListener("DOMContentLoaded", function () {
    const acuity_questions = document.getElementById("acuity_questions");
    if (!acuity_questions) return; // Prevents errors on pages without the element
    const aptTypeId = sessionStorage.getItem('aptId');
    if (aptTypeId && aptTypeId != 'undefined') {
        var data = {
            'appointmentTypeId': aptTypeId,
            'cluid': gbcGetCluid(),
        };
        console.log('[GBC cluid] shopify-get-patient-form (mobile) cluid:', data.cluid);
        jQuery.ajax(
            {
                url: "https://api.gbc.health/api/v2/shopify-get-patient-form",
                type: 'get',
                data: data,
                success: function (response) {
                    if (response.form) {
                        acuity_questions.innerHTML = response.form.form;
                    }
                },
            });
    } else {
        acuity_questions.innerHTML = '<div class="patientdet_formbox patientdet_formbox_dob"> \
                                <label class="patientdet_label inter_para_16" for="bdayinput">Date of Birth <span class="only"> (18+ only) *</span></label> \
                                <input class="rcb_input_box text-dark bdayinput" id="bdayinput" name="bdayinput" type="hidden" required="" value=""> \
                                <input class="form-control" onchange="update_bdate()" id="bdayday" min="1" max="31" type="number" required="" placeholder="DD"> \
                                <select class="form-control" onchange="update_bdate()" id="bdaymonth" required=""> \
                                  <option value="01">January</option>\
                                  <option value="02">February</option>\
                                  <option value="03">March</option>\
                                  <option value="04">April</option>\
                                  <option value="05">May</option>\
                                  <option value="06">June</option>\
                                  <option value="07">July</option>\
                                  <option value="08">August</option>\
                                  <option value="09">September</option>\
                                  <option value="10">October</option>\
                                  <option value="11">November</option>\
                                  <option value="12">December</option>\
                                </select>\
                                <input class="form-control" onchange="update_bdate()" id="bdayyear" min="1900" max="2022" type="number" required="" placeholder="YYYY"> \
                            </div>\
                        <div class="patientdet_formbox">\
                            <label for="InputGender" class="patientdet_label inter_para_16">Gender *</label>\
                            <select class="form-control important_input" id="InputGender" required aria-describedby="Gender" placeholder="" name="InputGender">\
                              <option>Male</option>\
                              <option>Female</option>\
                            </select>\
                        </div>';
    }

});

function submit_mobile_patient_form(event) {
    const form = document.getElementById('patient_details_form');
    const formValues = {};

    if (form) {
        const inputs = form.querySelectorAll('input, select, textarea'); // get all input fields
        inputs.forEach(input => {
            if (input.id) {
                formValues[input.id] = input.value;
                const val = input.value.toLowerCase(); // normalize

                if (val === 'male' || val === 'female' || val === 'prefer not to say') {
                    formValues['gender'] = input.value;
                }
            }
        });
    }

    // 18+ gate (enforced when DOB fields exist)
    if (shouldEnforceAdultCheck(form)) {
        const dob = deriveDobFromFormValues(formValues);
        if (!dob) {
            alert('Please enter a valid Date of Birth (18+ only) to continue.');
            return false;
        }
        // Normalize so booking-save payload has a consistent key
        formValues.bdayinput = dob;
        if (!isAtLeast18(dob)) {
            alert('Sorry — you must be 18+ to continue.');
            return false;
        }
    }

    sessionStorage.setItem('formValues', JSON.stringify(formValues));

    if (getHasMainPlans()) {
        sessionStorage.setItem('subscription_save_path', '/pages/mobile-booking-confirmation');
        sessionStorage.setItem('subscription_back_path', '/pages/mobile-patient-details');
        sessionStorage.removeItem('selectedUpsells');
        window.location.href = '/pages/mobile-booking-confirmation?subscription=1';
    } else {
        sessionStorage.removeItem('subscription_choices');
        window.location.href = '/pages/mobile-booking-confirmation';
    }
    return false;
}

document.addEventListener("DOMContentLoaded", function () {
    const p_form = document.getElementById('patient_details_form');
    if (!p_form) return;
    setTimeout(() => {
        const p_inputs = p_form.querySelectorAll('input, select, textarea'); // get all input fields
        formValues = sessionStorage.getItem('formValues');
        if (formValues) {
            data = JSON.parse(formValues);
            p_inputs.forEach(el => {
                const key = el.id || el.name;
                const val = data[key];
                if (el.tagName === 'SELECT') {
                    if ([...el.options].some(o => o.value == val)) {
                        el.value = val;
                    }
                    el.dispatchEvent(new Event('change', { bubbles: true }));
                } else if (el.type === 'checkbox') {
                    // store booleans as true/false when saving
                    el.checked = !!val || val === 'true' || val === 'on';
                    el.dispatchEvent(new Event('change', { bubbles: true }));

                } else if (el.type === 'radio') {
                    // expect radios saved by name -> value
                    if (el.name && data[el.name] != null) {
                        el.checked = (el.value == data[el.name]);
                        if (el.checked) el.dispatchEvent(new Event('change', { bubbles: true }));
                    }
                } else {
                    el.value = val ?? '';
                    el.dispatchEvent(new Event('input', { bubbles: true }));
                    el.dispatchEvent(new Event('change', { bubbles: true }));
                }
            });
        }
    }, 1500);

});

document.addEventListener("DOMContentLoaded", function () {
    const mobile_confirm_div = document.getElementById("mobile_confirm_block");
    if (!mobile_confirm_div) {
        return; // Prevents errors on pages without the element
    }
    const productTitle = sessionStorage.getItem('product_title');
    const variantId = sessionStorage.getItem('variant_id');
    const patientAddress1 = sessionStorage.getItem('patientAddress1');
    const patientAddress2 = sessionStorage.getItem('patientAddress2');
    const patientAddressStreet = sessionStorage.getItem('patientAddressStreet');
    const patientAddressTown = sessionStorage.getItem('patientAddressTown');
    const postCode = sessionStorage.getItem('postCode');
    const day1_val = sessionStorage.getItem('mobileDay1');
    const day2_val = sessionStorage.getItem('mobileDay2');
    const day3_val = sessionStorage.getItem('mobileDay3');

    var confirm_Html = "<p class='confirmbooking_title inter_subhead_sm'>" + productTitle + "</p>"
    //var confirm_Html = confirm_Html + "<p><b>" + variantId + "</b></p>"
    confirm_Html = confirm_Html + "<p class='checkavail_innpara inter_para_16' style='color: #171a2e;'>Book a home nurse visit to have your blood sample taken</p>";

    confirm_Html = confirm_Html + "<p class='confirmbooking_head inter_para'>Address</p>";
    if (patientAddress1 && patientAddress1 != 'undefined') {
        confirm_Html = confirm_Html + "<p class='confirmbooking_address inter_para_16'>" + patientAddress1 + ", </p>";
    }
    if (patientAddress2 && patientAddress2 != 'undefined') {
        confirm_Html = confirm_Html + "<p class='confirmbooking_address inter_para_16'>" + patientAddress2 + ", </p>";
    }
    if (patientAddressStreet && patientAddressStreet != 'undefined') {
        confirm_Html = confirm_Html + "<p class='confirmbooking_address inter_para_16'>" + patientAddressStreet + " </p>";
    }
    if (patientAddressTown && patientAddressTown != 'undefined') {
        confirm_Html = confirm_Html + "<p class='confirmbooking_address inter_para_16'>" + patientAddressTown + " </p>";
    }
    if (postCode && postCode != 'undefined') {
        confirm_Html = confirm_Html + "<p class='confirmbooking_address inter_para_16 text_center'>" + postCode + "</p>";
    }
    confirm_Html = confirm_Html + "<p class='confirmbooking_head inter_para'>Days Selected</p>";

    if (day1_val && day1_val != 'undefined') {
        confirm_Html = confirm_Html + "<p class='confirmbooking_address inter_para_16'>" + day1_val + "</p>";
    }

    if (day2_val && day2_val != 'undefined') {
        confirm_Html = confirm_Html + "<p class='confirmbooking_address inter_para_16'>" + day2_val + "</p>";
    }

    if (day3_val && day3_val != 'undefined') {
        confirm_Html = confirm_Html + "<p class='confirmbooking_address inter_para_16'>" + day3_val + "</p>";
    }

    mobile_confirm_div.innerHTML = confirm_Html;

});

document.addEventListener("DOMContentLoaded", function () {
    const mob_confirm_div = document.getElementById("mobile_confirm_save");
    if (!mob_confirm_div) {
        return; // Prevents errors on pages without the element
    }
    const aptTypeId = sessionStorage.getItem('aptId');
    const variantId = sessionStorage.getItem('variant_id');
    const variantSku = sessionStorage.getItem('variant_sku');

    const storedData = sessionStorage.getItem('formValues');
    console.log(variantId);
    console.log(variantSku);

    if (!storedData) return;
    let formValues; // use let so we can assign to it later
    try {
        formValues = JSON.parse(storedData);
    } catch (e) {
        console.error('Bad JSON in sessionStorage.formValues', storedData, e);
        return;
    }

    const day1Val = sessionStorage.getItem('mobileDay1');
    const day2Val = sessionStorage.getItem('mobileDay2');
    const day3Val = sessionStorage.getItem('mobileDay3');
    const patientAddress1 = sessionStorage.getItem('patientAddress1');
    const patientAddress2 = sessionStorage.getItem('patientAddress2');
    const patientAddressStreet = sessionStorage.getItem('patientAddressStreet');
    const patientAddressTown = sessionStorage.getItem('patientAddressTown');
    const postCode = sessionStorage.getItem('postCode');

    const data = JSON.stringify({
        'appointmentTypeId': aptTypeId,
        'firstName': formValues.InputFName,
        'lastName': formValues.InputSName,
        'email': formValues.InputEmail,
        'phoneNumber': formValues.InputPhone,
        'dob': formValues.bdayinput,
        'gender': formValues.gender,
        'formData': formValues,
        'day1Val': day1Val,
        'day2Val': day2Val,
        'day3Val': day3Val,
        'patientAddress1': patientAddress1,
        'patientAddress2': patientAddress2,
        'patientAddressStreet': patientAddressStreet,
        'patientAddressTown': patientAddressTown,
        'postCode': postCode,
        'notes': formValues.field_notes,
        'sku': variantSku,
        'cluid': gbcGetCluid(),
    });
    console.log('[GBC cluid] shopify-make-mobile-booking cluid:', gbcGetCluid());

    jQuery.ajax({
        url: "https://api.gbc.health/api/v2/shopify-make-mobile-booking",
        type: 'POST',
        data: data,
        contentType: 'application/json',  // send JSON
        processData: false,               // don't URL encode
        success: function (response) {
            console.log('✅ Success:', response.id);

            addToCartFromSession(response.id);

        },
        error: function (xhr, status, error) {
            console.error('❌ Error:', error, xhr.responseText);
        },
    });

});

// ============================================
// UPSELL RENDERING - New Design
// ============================================

// Helper function to parse price strings that may contain commas (e.g., "1,499.00")
function parsePrice(priceString) {
    if (window.GbcSubscriptionShared && typeof window.GbcSubscriptionShared.parsePrice === 'function') {
        return window.GbcSubscriptionShared.parsePrice(priceString);
    }
    if (typeof priceString === 'number') {
        return priceString;
    }
    if (typeof priceString !== 'string') {
        return 0;
    }
    return parseFloat(priceString.replace(/,/g, '')) || 0;
}

// Helper function to render product summary (header right side)
function renderProductSummary(containerId, type = 'clinic') {
    const container = document.getElementById(containerId);
    if (!container) return;

    const productTitle = sessionStorage.getItem('product_title') || 'Product';
    const clinicName = sessionStorage.getItem('clinicName') || '';

    // Get variant description based on type
    const variantText = type === 'mobile'
        ? 'Book a home nurse visit to have your blood sample taken'
        : 'Blood taken by a professional in-clinic';

    // Get location based on type
    let locationText = '';
    if (type === 'mobile') {
        const address1 = sessionStorage.getItem('patientAddress1') || '';
        const street = sessionStorage.getItem('patientAddressStreet') || '';
        const town = sessionStorage.getItem('patientAddressTown') || '';
        locationText = [address1, street, town].filter(Boolean).join(', ');
    } else {
        locationText = clinicName;
    }

    // Date(s) line (matches previous confirm_block behaviour)
    let dateLineHtml = '';
    if (type === 'mobile') {
        const day1 = sessionStorage.getItem('mobileDay1') || '';
        const day2 = sessionStorage.getItem('mobileDay2') || '';
        const day3 = sessionStorage.getItem('mobileDay3') || '';
        const days = [day1, day2, day3].filter(Boolean);
        if (days.length) {
            // Render each selected day on its own line to avoid an overly long single line
            dateLineHtml = `<p class="product-summary-date">${ days.map(d => `<span class="product-summary-date__line">${ d }</span>`).join('') }</p>`;
        }
    } else {
        const timeCode = sessionStorage.getItem('timecode');
        if (timeCode) {
            const date = new Date(timeCode);
            if (!Number.isNaN(date.getTime())) {
                const day = String(date.getDate()).padStart(2, '0');
                const month = String(date.getMonth() + 1).padStart(2, '0');
                const year = date.getFullYear();
                const hours = String(date.getHours()).padStart(2, '0');
                const minutes = String(date.getMinutes()).padStart(2, '0');
                const formattedDate = `${ day }/${ month }/${ year } at ${ hours }:${ minutes }`;
                dateLineHtml = `<p class="product-summary-date">${ formattedDate }</p>`;
            }
        }
    }

    container.innerHTML = `
        <div class="product-summary">
            <div class="product-summary-check">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2.5">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M5 13l4 4L19 7" />
                </svg>
            </div>
            <div class="product-summary-info">
                <h3 class="product-summary-title">${ productTitle }</h3>
                <p class="product-summary-variant">${ variantText }</p>
                ${ locationText ? `<p class="product-summary-location">${ locationText }</p>` : '' }
                ${ dateLineHtml }
            </div>
        </div>
    `;
}

// Reusable function to render upsells with new card design
function renderUpsells(blockId, listId, specialTitles, discountAmount) {
    const upsells_block = document.getElementById(blockId);
    if (!upsells_block) return;

    const upsells = sessionStorage.getItem('upsells');
    if (!upsells) {
        upsells_block.style.display = "none";
        return;
    }

    let upsellProducts;
    try {
        upsellProducts = JSON.parse(upsells);
    } catch (e) {
        console.error('Bad JSON in sessionStorage.upsells', upsells, e);
        return;
    }

    const upsellList = document.getElementById(listId);
    if (!upsellList) {
        console.error(`Upsell list element not found: ${ listId }`);
        return;
    }

    upsellList.innerHTML = '';
    let hasValidUpsells = false;

    upsellProducts.forEach((product, index) => {
        let product_id;
        let product_price;
        let product_discount;
        let variant_title = '';
        let selling_plan_id = null;
        let selling_plans = [];

        // Determine variant and pricing
        if (product.title.toLowerCase().includes('gp consultation') || product.title.toLowerCase().includes('mri')) {
            if (product.variants && product.variants.length > 0) {
                const variant = product.variants[0];
                product_id = variant.id;
                product_price = parsePrice(product.price);
                product_discount = 0;
                variant_title = variant.title || '';
                selling_plan_id = variant.selling_plan_id || null;
                selling_plans = variant.selling_plans || [];
            }
        } else {
            if (product.variants && product.variants.length > 0) {
                product.variants.forEach(variant => {
                    if (specialTitles.includes(variant.title)) {
                        product_id = variant.id;
                        product_price = parsePrice(variant.price) - discountAmount;
                        product_discount = discountAmount;
                        variant_title = variant.title || '';
                        selling_plan_id = variant.selling_plan_id || null;
                        selling_plans = variant.selling_plans || [];
                    }
                });
            }
        }

        if (product_id) {
            hasValidUpsells = true;
            logDiscountDebug('Upsell variant selected', {
                flow: listId.indexOf('mobile') !== -1 ? 'book-at-home' : 'in-clinic',
                upsell_product_title: product.title || '',
                upsell_variant_id: Number(product_id),
                upsell_variant_title: variant_title || '',
                matched_titles: specialTitles,
                calculated_display_price: Number(product_price),
                ui_discount_amount: Number(product_discount || 0),
            });
            const cardId = `upsell_card_${ index }`;
            const checkboxId = `upsell_${ index }`;
            const productImage = product.image || '';
            const productImageAlt = product.image_alt || product.title || '';
            const priceFormatted = product_price.toFixed(2);
            const sellingPlansJson = JSON.stringify(selling_plans || []);

            const card = document.createElement('div');
            card.className = 'upsell-card';
            card.id = cardId;
            card.innerHTML = `
        <input 
          type="checkbox" 
                    class="bolt_on_option_box" 
          id="${ checkboxId }" 
          value="${ product_id }" 
          data-desc_title="${ (product.title || '').replace(/"/g, '&quot;') }"
                    data-handle="${ product.handle || '' }"
                    data-eurofins_code="${ product.eurofins_code || '' }"
                    data-price="${ product_price }"
                    data-original_price="${ product_price + (product_discount || 0) }"
                    data-discount_amount="${ product_discount || 0 }"
                    data-variant_title="${ (variant_title || '').replace(/"/g, '&quot;') }"
                    data-selling_plan_id="${ selling_plan_id || '' }"
                    data-selling_plans="${ (sellingPlansJson || '[]').replace(/"/g, '&quot;') }"
                    style="display: none;">
                ${ productImage
                ? `<img src="${ productImage }" alt="${ productImageAlt }" class="upsell-card__image" loading="lazy">`
                : '<div class="upsell-card__image"></div>' }
                <div class="upsell-card__content">
                    <h4 class="upsell-card__title">${ product.title }</h4>
                    <span class="upsell-card__info-link" data-description="${ (product.description || '').replace(/"/g, '&quot;') }">
                        What is this? <span class="upsell-card__info-icon">?</span>
                    </span>
                    <div class="upsell-card__tooltip" role="tooltip" hidden>
                        <div class="upsell-card__tooltip-content">
                            <button class="upsell-card__tooltip-close" aria-label="Close tooltip">×</button>
                            <div class="upsell-card__tooltip-text"></div>
                        </div>
                    </div>
                </div>
                <div class="upsell-card__actions">
                    ${ product_discount > 0
                ? `<span class="upsell-card__discount">&pound;${ product_discount.toFixed(2) } off regular price</span>`
                : '' }
                    <button type="button" class="upsell-card__add-btn" data-card-id="${ cardId }" data-checkbox-id="${ checkboxId }">
                        Add (+&pound;${ priceFormatted })
                    </button>
                </div>
        `;
            upsellList.appendChild(card);
        }
    });

    // Show/hide block based on valid upsells
    upsells_block.style.display = hasValidUpsells ? "block" : "none";

    // Add click handlers for Add buttons
    upsellList.querySelectorAll('.upsell-card__add-btn').forEach(btn => {
        btn.addEventListener('click', function () {
            const cardId = this.dataset.cardId;
            const checkboxId = this.dataset.checkboxId;
            const card = document.getElementById(cardId);
            const checkbox = document.getElementById(checkboxId);

            if (card && checkbox) {
                checkbox.checked = !checkbox.checked;
                card.classList.toggle('upsell-card--selected', checkbox.checked);

                if (checkbox.checked) {
                    this.textContent = 'Added ✓';
                    this.classList.add('upsell-card__add-btn--added');
                } else {
                    const price = parseFloat(checkbox.dataset.price).toFixed(2);
                    this.textContent = `Add (+£${ price })`;
                    this.classList.remove('upsell-card__add-btn--added');
                }
            }
        });
    });

    // Add click handlers for "What is this?" tooltips
    upsellList.querySelectorAll('.upsell-card__info-link').forEach(link => {
        const tooltip = link.nextElementSibling;
        const tooltipText = tooltip?.querySelector('.upsell-card__tooltip-text');
        const closeButton = tooltip?.querySelector('.upsell-card__tooltip-close');
        const description = link.dataset.description || 'No description available.';

        if (!tooltip || !tooltipText) return;

        // Open tooltip on click
        link.addEventListener('click', function (e) {
            e.preventDefault();
            e.stopPropagation();

            // Close any other open tooltips
            upsellList.querySelectorAll('.upsell-card__tooltip').forEach(t => {
                if (t !== tooltip) {
                    t.setAttribute('hidden', '');
                    t.previousElementSibling?.classList.remove('upsell-card__info-link--active');
                }
            });

            // Toggle this tooltip
            const isHidden = tooltip.hasAttribute('hidden');
            if (isHidden) {
                tooltipText.textContent = description;
                tooltip.removeAttribute('hidden');
                link.classList.add('upsell-card__info-link--active');
                link.setAttribute('aria-expanded', 'true');
            } else {
                tooltip.setAttribute('hidden', '');
                link.classList.remove('upsell-card__info-link--active');
                link.setAttribute('aria-expanded', 'false');
            }
        });

        // Close tooltip on close button click
        if (closeButton) {
            closeButton.addEventListener('click', function (e) {
                e.preventDefault();
                e.stopPropagation();
                tooltip.setAttribute('hidden', '');
                link.classList.remove('upsell-card__info-link--active');
                link.setAttribute('aria-expanded', 'false');
            });
        }

        // Close tooltip when clicking outside
        document.addEventListener('click', function (e) {
            if (!tooltip.contains(e.target) && !link.contains(e.target)) {
                if (!tooltip.hasAttribute('hidden')) {
                    tooltip.setAttribute('hidden', '');
                    link.classList.remove('upsell-card__info-link--active');
                    link.setAttribute('aria-expanded', 'false');
                }
            }
        });

        // Close tooltip on Escape key
        document.addEventListener('keydown', function (e) {
            if (e.key === 'Escape' && !tooltip.hasAttribute('hidden')) {
                tooltip.setAttribute('hidden', '');
                link.classList.remove('upsell-card__info-link--active');
                link.setAttribute('aria-expanded', 'false');
            }
        });
    });
}

// Initialize booking confirmation pages
document.addEventListener("DOMContentLoaded", function () {
    // In-clinic booking - check for booking_summary_clinic container (new design)
    const clinicSummaryContainer = document.getElementById('booking_summary_clinic');
    if (clinicSummaryContainer) {
        updateConfirmBackLink('.booking-actions__back', '/pages/patient-details');
        renderProductSummary('booking_summary_clinic', 'clinic');
        renderUpsells('bolton_block', 'bolton_list', ["Blood taken by a professional in-clinic"], 30);
    }

    // Mobile booking - check for booking_summary_mobile container (new design)
    const mobileSummaryContainer = document.getElementById('booking_summary_mobile');
    if (mobileSummaryContainer) {
        updateConfirmBackLink('.booking-actions__back', '/pages/mobile-patient-details');
        renderProductSummary('booking_summary_mobile', 'mobile');
        renderUpsells('mobile_bolton_block', 'mobile_bolton_list', ["Book a home nurse visit to have your blood sample taken"], 30);
    }
});

document.addEventListener("DOMContentLoaded", function () {
    const bookingConfirm = document.getElementById("booking_confirm");
    if (!bookingConfirm) {
        return;
    }
    $('#booking_confirm').on('click', function (e) {
        e.preventDefault();
        saveUpsellsAndFinish({
            savePath: '/pages/booking-save',
        });
    });
});

document.addEventListener("DOMContentLoaded", function () {
    const mobileBookingConfirm = document.getElementById("mobile_booking_confirm");
    if (!mobileBookingConfirm) {
        return;
    }
    $('#mobile_booking_confirm').on('click', function (e) {
        e.preventDefault();
        saveUpsellsAndFinish({
            savePath: '/pages/mobile-booking-save',
        });
    });
});

// ----- Subscription step page (dedicated page or inline on confirm pages) -----
document.addEventListener("DOMContentLoaded", function () {
    var isDedicatedSubscriptionPage = window.location.pathname === "/pages/booking-subscription";
    var subscriptionQuery = null;
    try {
        subscriptionQuery = new URLSearchParams(window.location.search).get('subscription');
    } catch (e) {
    }
    var isInlineSubscriptionStep = subscriptionQuery === '1';

    var root = document.getElementById("subscription-step-root");
    if (!root || (!isDedicatedSubscriptionPage && !isInlineSubscriptionStep)) return;

    var content = document.getElementById("subscription-step-content");
    if (!content) return;

    if (isInlineSubscriptionStep) {
        showBookingStep(root);
    }

    var variantId = sessionStorage.getItem("variant_id");
    var mainVariantSellingPlanId = sessionStorage.getItem("main_variant_selling_plan_id");
    var mainVariantSellingPlansStr = sessionStorage.getItem("main_variant_selling_plans");
    var productTitle = sessionStorage.getItem("product_title") || "Main product";
    var mainVariantSellingPlans = [];
    try {
        if (mainVariantSellingPlansStr) mainVariantSellingPlans = JSON.parse(mainVariantSellingPlansStr);
    } catch (e) {
    }

    var subscriptionSavePath = sessionStorage.getItem('subscription_save_path') || "/pages/booking-save";
    var subscriptionBackPath = sessionStorage.getItem('subscription_back_path') || "/pages/booking-confirm";
    // If missing required data, skip to the configured save page.
    if (!variantId) {
        window.location.href = subscriptionSavePath;
        return;
    }
    // For clinic/mobile booking flows, subscription step is only relevant when main product has plans.
    if (mainVariantSellingPlans.length === 0) {
        window.location.href = subscriptionSavePath;
        return;
    }

    function updateSubscribeOptionUi(subscribeOption, selectedPlanPrice) {
        if (!subscribeOption) return;
        var pricesWrap = subscribeOption.querySelector('.subscription-step__option-prices');
        if (!pricesWrap) return;

        var originalNode = pricesWrap.querySelector('.subscription-step__original-price');
        var discountedNode = pricesWrap.querySelector('.subscription-step__discounted-price');
        if (!originalNode || !discountedNode) return;

        var originalPrice = parsePrice((originalNode.textContent || '').replace(/[^\d.,-]/g, ''));
        var planPrice = parsePrice(selectedPlanPrice);
        if (!planPrice) return;

        discountedNode.textContent = '£' + planPrice.toFixed(2);

        if (originalPrice > planPrice) {
            var savePct = Math.round(((originalPrice - planPrice) / originalPrice) * 100);
            if (savePct > 0) {
                var badgeNode = subscribeOption.querySelector('.subscription-step__option-badge');
                if (badgeNode) {
                    var maxDiscount = Number(subscribeOption.dataset.maxDiscount || 0);
                    // badgeNode.textContent = 'Save up to ' + (maxDiscount || savePct) + '%';
                    badgeNode.textContent = 'MOST POPULAR';
                }

                var firstBenefit = subscribeOption.querySelector('.subscription-step__option-benefits li');
                if (firstBenefit) firstBenefit.textContent = 'Save ' + savePct + '%';
            }
        }
    }

    function buildSubscriptionChoices() {
        var shared = window.GbcSubscriptionShared;
        if (!shared || typeof shared.collectChoices !== 'function') {
            return { main: null, upsells: [] };
        }
        return shared.collectChoices(content);
    }

    var mainPrice = parsePrice(sessionStorage.getItem("main_variant_price") || "0");
    var mainPlans = mainVariantSellingPlans;
    var isMobileSubscriptionStep = false;
    try {
        isMobileSubscriptionStep = window.matchMedia('(max-width: 767px)').matches;
    } catch (e) {
    }
    var shared = window.GbcSubscriptionShared;
    if (!shared || typeof shared.buildSubscriptionStepHtml !== 'function') {
        console.error('GbcSubscriptionShared.buildSubscriptionStepHtml is required');
        return;
    }
    var html = shared.buildSubscriptionStepHtml({
        wrapInContainer: false,
        //withOptionHeader: isMobileSubscriptionStep,
        withOptionHeader: true,
        planButtonStyle: 'split',
        requireMainSellingPlanId: true,
        heading: 'Choose purchase option',
        productTitle: productTitle,
        mainPrice: mainPrice,
        mainVariantSellingPlanId: mainVariantSellingPlanId,
        mainVariantSellingPlans: mainPlans,
        forceUpsellsOneTime: false,
        upsells: [],
        actionsHtml:
            '<div class="subscription-step__actions">' +
            '<a href="' + subscriptionBackPath.replace(/"/g, '&quot;') + '" class="subscription-step__back">Back</a>' +
            '<button type="button" class="subscription-step__continue" id="subscription-step-continue">Continue</button>' +
            '</div>',
    });

    content.innerHTML = html;
    shared.bindOptionSelection(content);
    shared.bindPlanButtons(content, {
        onPlanChange: function (ctx) {
            if (ctx.button.dataset.planPrice) {
                updateSubscribeOptionUi(ctx.subscribeOption, ctx.button.dataset.planPrice);
            }
        },
    });

    document.getElementById("subscription-step-continue").addEventListener("click", function () {
        var choices = buildSubscriptionChoices();
        sessionStorage.setItem("subscription_choices", JSON.stringify(choices));
        window.location.href = subscriptionSavePath;
    });
});
